module.exports = __webpack_public_path__ + "static/media/MY-UKM.d93eaafb.png";